export default __webpack_public_path__ + "static/media/avatar.389d0393.jpg";